import {Component, OnInit, Input, ViewChild, HostListener, ElementRef} from '@angular/core';
import { NotesService } from '../../../services/notes.service';
import {
  _testNotesGlobals
} from '../models/Notes.models';
import { MessagingService } from '../../../services/messaging.service';
import { TdoMultiselectDropdownComponent } from '../../../tdo-controls/common/tdo-multiselect-dropdown/tdo-multiselect-dropdown.component';
import {NoteDataModel} from '../../../models/notes/note-data.model';
import {EnumValidValueModel} from '../../../models/enum/enum-valid-value.model';
import {NoteGroupDataModel} from '../../../models/notes/note-group-data.model';
import {NoteGroupDescriptionModel} from '../../../models/notes/note-group-description.model';
import {MessagingConstants} from '../../../models/MessagingConstants';

@Component({
  selector: 'app-note-main',
  templateUrl: './note-main.component.html',
  styleUrls: ['./note-main.component.css']
})
export class NoteMainComponent implements OnInit {
  @ViewChild('categorySelector') categorySelector: TdoMultiselectDropdownComponent;
  @ViewChild('typeSelector') typeSelector: TdoMultiselectDropdownComponent;

  @Input() listenToNoteQueryEvents: boolean = true;

  @Input() PatientID: string;
  @Input() CaseID: string;
  @Input() PatientName: string;
  @Input() NoteGroupId: string;
  @Input() ParentObjectName: string;
  @Input() ObjectId: string;

  @Input() categoryFilters: any[] = [];
  @Input() filteredMode: boolean = false;
  @Input() showAllFilter: any = { displayValue: 'Show all', selected: true };

  startupWithoutParams: boolean = true;
  messagingSubscription: any;
  hideFilterButton: boolean = false;
  isLoading: boolean = false;
  deleteMode: boolean = false;
  hideFilters: boolean = true;
  dataNoteGroups: NoteGroupDataModel[] = [];
  dataNoteCategoryEnums: EnumValidValueModel;
  dataNoteTypeEnums: EnumValidValueModel;

  objectsRelatedToPatient: NoteGroupDescriptionModel[] = [];
  selectedRelatedObjects: NoteGroupDescriptionModel[] = [];
  fetchObjectsRelatedSubscription: any = false;

  selectedCategories: string[];
  selectedTypes: string[];
  private isInitialized: boolean;

  constructor(
    private notesGlobals: _testNotesGlobals,
    private notesService: NotesService,
    private messagingService: MessagingService,
    private el: ElementRef
  ) { }

  @HostListener('document:click', ['$event'])
  checkIfClickOutside(event) {
    const tar = event.target;
    if (!this.el.nativeElement.contains(event.target) && this.isInitialized) {
      this.messagingService.broadCastMessage('Toggle-Notes-Display', { display: false });
    }
  }

  ngOnInit() {
    // Timeout added so that the @HostListener event responsible for closing when clicking outside
    // does not fire from the icon click itself.
    setTimeout(() => {
      this.isInitialized = true;
    }, 0.1);
    // this.dataNoteGroups[0].dataNote.Note

    // testing
    // this.ObjectId = this.notesGlobals.NOTE_GROUP_OBJECTID;
    // this.ParentObjectName = 'dataPatient';
    // this.PatientName = "Bob Smith";
    // end test

    if (this.ObjectId || this.PatientID || this.NoteGroupId) {
      this.initWithQueryObj();
    }

    if (this.filteredMode) {
      this.hideFilters = true;
      this.hideFilterButton = true;
    }

    this.messagingSubscription = this.messagingService.componentMessageCall
      .subscribe(response => {
        console.log('------------------------');
        console.log('NOTE');
        console.log(response);

        if (response.event === MessagingConstants.PATIENT_CHANGED && this.listenToNoteQueryEvents) {
          if (response.data.clearCurrentQuery) { this.clearCurrentQuery(); }
          this.PatientID = response.data.PatientID;
          this.PatientName = response.data.PatientName;
          this.initWithQueryObj();
        }

        if (response.event === 'Notes-Set-Filters' && this.listenToNoteQueryEvents) {
          this.filteredMode = true;
          this.categoryFilters = response.data.categoryFilters;
        }

        if (response.event === 'Notes-Startup' && this.listenToNoteQueryEvents) {
          this.clearCurrentQuery();
          this.PatientID = response.data.PatientID;
          this.CaseID = response.data.CaseID;
          this.PatientName = response.data.PatientName;
          this.NoteGroupId = response.data.NoteGroupId;
          this.ParentObjectName = response.data.ParentObjectName;
          this.ObjectId = response.data.ObjectID;
          this.initWithQueryObj();
        }

        if (response.event == 'NoteGroup-Changed-Event' && this.listenToNoteQueryEvents) {
          if (response.data.clearCurrentQuery) { this.clearCurrentQuery(); }
          this.NoteGroupId = response.data.NoteGroupId;
          this.initWithQueryObj();
        }

        if (response.event == 'NoteParentObject-Changed-Event' && this.listenToNoteQueryEvents) {
          if (response.data.clearCurrentQuery) { this.clearCurrentQuery(); }
          this.ObjectId = response.data.ObjectID;
          this.ParentObjectName = response.data.ParentObjectName;
          this.initWithQueryObj();
        }

        if (response.event == 'Notes-Query' && this.listenToNoteQueryEvents) {
          this.clearCurrentQuery();
          this.PatientID = response.data.PatientID;
          this.NoteGroupId = response.data.NoteGroupId;
          this.PatientName = response.data.PatientName;
          this.ParentObjectName = response.data.ParentObjectName;
          this.ObjectId = response.data.ObjectID;
          this.initWithQueryObj();
        }

        if (response.event == 'Notes-Query-Update' && this.listenToNoteQueryEvents) {

          for (const i in response.data) {
            this[i] = response.data[i];
            console.log(this[i]);
          }

          // this.PatientID = response.data.PatientID;
          // this.NoteGroupId = response.data.NoteGroupId;
          // this.PatientName = response.data.PatientName;
          // this.ParentObjectName = response.data.ParentObjectName;
          // this.ObjectId = response.data.ObjectID;

          this.initWithQueryObj();
        }


      });

  }

  fetchObjectsRelatedToPatient() {
    this.objectsRelatedToPatient = [];

    if (this.fetchObjectsRelatedSubscription) {
      this.fetchObjectsRelatedSubscription.unsubscribe();
      this.fetchObjectsRelatedSubscription = false;
    }

    this.fetchObjectsRelatedSubscription = this.notesService.getPatientNoteObjectOptions(this.PatientID)
      .subscribe(response => {
        this.objectsRelatedToPatient = response;

        const noneObject = new NoteGroupDescriptionModel();
        noneObject.ObjectDescription = 'All notes';
        noneObject.ObjectId = 'NONE';
        noneObject.ObjectName = 'NONE';

        this.objectsRelatedToPatient.unshift(noneObject);

        this.fetchObjectsRelatedSubscription = false;
      }, err => {
        this.fetchObjectsRelatedSubscription = false;
      });
  }

  clearCurrentQuery() {
    this.PatientID = null;
    this.NoteGroupId = null;
    this.ObjectId = null;
    this.ParentObjectName = null;
  }

  orderNotes() {
    this.dataNoteGroups = this.dataNoteGroups.sort((a, b) => {
      const d1 = new Date(a.dataNote.xauditModifiedOn);
      const d2 = new Date(b.dataNote.xauditModifiedOn);
      if (d1 > d2) {
        return -1;
      } else if (d2 > d1) {
        return 1;
      } else {
        return 0;
      }
    });
  }

  filterDeletedNotes() {
    this.dataNoteGroups = this.dataNoteGroups.filter(ng => ng.xauditDeleted == false);
  }

  filterNotes() {
    let showAllFlag = false;
    if (this.showAllFilter.selected) {
      showAllFlag = true;
    }

    this.dataNoteGroups.forEach(noteGroup => {
      let flag = false;
      this.categoryFilters.forEach(filter => {
        if (filter.selected) {
          noteGroup.dataNote.dataNoteCategories.forEach(category => {
            if (category.xauditDeleted == false && category.enumNoteCategory.ItemDisplayValue === filter.displayValue) {
              flag = true;
            }
          });
        }
      });
      noteGroup.display = flag || showAllFlag;
    });
  }

  buildQuery() {
    const query = {
      PatientID: this.PatientID,
      NoteGroupId: this.NoteGroupId,
      ObjectID: this.ObjectId,
    };
    return query;
  }

  initWithQueryObj() {
    this.startupWithoutParams = false;
    this.isLoading = true;
    const promises = [
      this.fetchNoteGroupsByQueryObj(this.buildQuery()),
      this.fetchNoteCategoryEnums(),
      this.fetchNoteTypeEnums()
    ];
    this.fetchObjectsRelatedToPatient();
    Promise.all(promises).then((results: any[]) => {
      this.isLoading = false;
      this.dataNoteGroups = results[0];
      this.dataNoteCategoryEnums = results[1];
      this.dataNoteTypeEnums = results[2];
      this.selectedCategories = this.dataNoteCategoryEnums.enumValidValueItems.map(o => o.ValidValueItemId);
      this.selectedTypes = this.dataNoteTypeEnums.enumValidValueItems.map(o => o.ValidValueItemId);
      this.filterDeletedNotes();
      this.orderNotes();

      if (!this.filteredMode) {
        this.setupCategoryFilters();
      } else {
        this.filterNotes();
      }

    }, err => {
      this.isLoading = false;
      console.log(err);
      this.messagingService.sendComponentMessage('notesDisplayWarning', {
        message: 'Whoops... something went wrong'
      });
    });
  }

  fetchNoteGroupsByQueryObj(queryObj: any) {
    const promise = new Promise((resolve, reject) => {
      this.notesService.getNoteByQuery(queryObj)
        .subscribe(response => {
          resolve(response);
        }, err => {
          reject(err);
        });
    });
    return promise;
  }

  initWithObjectId() {
    this.isLoading = true;

    const promises = [
      this.fetchNoteGroupByObjectId(this.ObjectId),
      this.fetchNoteCategoryEnums()
    ];

    Promise.all(promises).then((results: any[]) => {
      this.isLoading = false;
      this.dataNoteGroups = results[0];
      this.dataNoteCategoryEnums = results[1];
      this.filterDeletedNotes();
      this.orderNotes();

      if (!this.filteredMode) {
        this.setupCategoryFilters();
      } else {
        this.filterNotes();
      }

    }, err => {
      this.isLoading = false;
      console.log(err);
      this.messagingService.sendComponentMessage('notesDisplayWarning', {
        message: 'Whoops... something went wrong'
      });
    });
  }

  fetchNoteTypeEnums() {
    const promise = new Promise((resolve, reject) => {
      this.notesService.getNoteTypeEnums()
        .subscribe(response => {
          resolve(response);
        }, err => {
          reject(err);
        });
    });
    return promise;
  }

  fetchNoteCategoryEnums() {
    const promise = new Promise((resolve, reject) => {
      this.notesService.getNoteCategoryEnums()
        .subscribe(response => {
          resolve(response);
        }, err => {
          reject(err);
        });
    });
    return promise;
  }

  fetchNoteGroupById(noteGroupId: string) {
    const promise = new Promise((resolve, reject) => {
      this.notesService.getNoteGroupById(noteGroupId)
        .subscribe(response => {
          resolve(response);
        }, err => { reject(err); });
    });
    return promise;
  }

  fetchNoteGroupByObjectId(objectId: string) {
    const promise = new Promise((resolve, reject) => {
      this.notesService.getNoteGroupsByObjectId(objectId)
        .subscribe(response => {
          resolve(response);
        }, err => { reject(err); });
    });
    return promise;
  }

  fetchNoteGroupByPatientId(patientId: string) {
    const promise = new Promise((resolve, reject) => {

    });
    return promise;
  }

  onShowAllFilterClick(): void {
    if (this.showAllFilter.selected) {
      this.categorySelector.selectAll();
      this.typeSelector.selectAll();
    }
    else {
      this.categorySelector.deselectAll();
      this.typeSelector.deselectAll();
    }
  }

  onCategoryChanged(categoryIds: any[]) {
    if (categoryIds.length !== this.dataNoteCategoryEnums.enumValidValueItems.length) {
      this.showAllFilter.selected = false;
    }

    // this.updateFilter(categoryIds);
    const showAllFlag: boolean = this.showAllFilter.selected;

    this.dataNoteGroups.forEach(noteGroup => {
      let flag = false;

      categoryIds.forEach(selectedCat => {
        noteGroup.dataNote.dataNoteCategories.forEach(cat => {
          if (!cat.xauditDeleted && cat.enumNoteCategory.ValidValueItemId === selectedCat) {
            flag = true;
          }
        });
      });

      noteGroup.display = flag || showAllFlag;
    });
  }

  onRelatedObjectsChanged(relatedObjectIds: any[]) {

    console.log('onRelatedObjectsChanged', relatedObjectIds);

    const selectedObjectId = relatedObjectIds[0];
    this.hideFilters = true;

    if (selectedObjectId === 'NONE') {
      this.ObjectId = null;
      this.ParentObjectName = null;
      this.initWithQueryObj();
      return;
    }

    const relatedObjectDescription = this.objectsRelatedToPatient.find(obj => {
      return obj.ObjectId === selectedObjectId;
    });

    this.ObjectId = relatedObjectDescription.ObjectId;
    this.ParentObjectName = relatedObjectDescription.ObjectName;

    this.initWithQueryObj();
  }

  onTypesChanged(typeIds: any[]) {
    if (typeIds.length !== this.dataNoteTypeEnums.enumValidValueItems.length) {
      this.showAllFilter.selected = false;
    }

    // this.updateFilter(typeIds);
    const showAllFlag: boolean = this.showAllFilter.selected;

    this.dataNoteGroups.forEach(noteGroup => {
      let flag = false;

      typeIds.forEach(selectedCat => {
        noteGroup.dataNote.dataNoteTypes.forEach(type => {
          if (!type.xauditDeleted && type.enumNoteType.ValidValueItemId === selectedCat) {
            flag = true;
          }
        });
      });

      noteGroup.display = flag || showAllFlag;
    });
  }

  setupCategoryFilters() {
    this.categoryFilters = [];
    this.dataNoteGroups.forEach(noteGroup => {
      noteGroup.display = true;
    });
    this.dataNoteCategoryEnums.enumValidValueItems.forEach(cat => {
      this.categoryFilters.push({
        displayValue: cat.ItemDisplayValue,
        selected: true,
      });
    });
  }

  deleteNoteGroup(noteGroup: NoteGroupDataModel) {
    noteGroup.xauditDeleted = true;
    const bkNoteGroup: NoteGroupDataModel = JSON.parse(JSON.stringify(noteGroup));
    delete bkNoteGroup.dataNote;

    this.filterDeletedNotes();
    this.orderNotes();

    this.saveNoteGroup(bkNoteGroup)
      .then(result => {
      }, err => {
        console.log('err');
        this.messagingService.sendComponentMessage('notesDisplayWarning', {
          message: 'Whoops... something went wrong'
        });
      });
  }

  saveNoteGroup(noteGroup: NoteGroupDataModel) {
    const promise = new Promise((resolve, reject) => {
      this.notesService.saveNoteGroup(noteGroup)
        .subscribe(response => {
          resolve(response);
        }, err => {
          reject(err);
        });

    });
    return promise;
  }

  createNoteGroup() {
    this.isLoading = true;
    let newNoteGroup = new NoteGroupDataModel();
    newNoteGroup.ObjectId = this.ObjectId;
    newNoteGroup.ParentObjectName = this.ParentObjectName;
    newNoteGroup.PatientId = this.PatientID;

    if (!newNoteGroup.ObjectId) {
      newNoteGroup.ObjectId = this.PatientID;
      newNoteGroup.ParentObjectName = 'dataPatient';
    }

    let newDataNote = new NoteDataModel();
    newDataNote.Note = '';

    this.saveDataNote(newDataNote)
      .then((result: NoteDataModel) => {
        newDataNote = result;
        newNoteGroup.NoteId = newDataNote.NoteId;

        this.saveNoteGroup(newNoteGroup)
          .then((result: NoteGroupDataModel) => {
            newNoteGroup = result;
            newNoteGroup.dataNote = newDataNote;
            newNoteGroup.display = true;
            this.dataNoteGroups.unshift(newNoteGroup);
            this.isLoading = false;
            this.messagingService.sendComponentMessage('notesDisplaySuccess', {
              message: 'Note created'
            });
          }, err => {
            this.isLoading = false;
            console.log('err', err);
            this.messagingService.sendComponentMessage('notesDisplayWarning', {
              message: 'Whoops... something went wrong'
            });
          });

      }, err => {
        this.isLoading = false;
        console.log('err', err);
        this.messagingService.sendComponentMessage('notesDisplayWarning', {
          message: 'Whoops... something went wrong'
        });
      });
  }

  saveDataNote(note: NoteDataModel) {
    const promise = new Promise((resolve, reject) => {
      this.notesService.saveDataNote(note)
        .subscribe(response => {
          resolve(response);
        }, err => {
          reject(err);
        });
    });
    return promise;
  }

  onCloseClick(): void {
    this.messagingService.sendComponentMessage('Toggle-Notes-Display', { display: false });
  }
}
